import { ActionTypes } from "../constants";

const reduceError = (state = [], action) => {
    if (!action.type) { return state; }

    if (action.type === ActionTypes.CLEAR_ERRORS) { return []; }

    if (action.type.endsWith('_REQUEST') && !!state) {
        return state.filter(({failedAction}) => failedAction !== action.type);
    }

    if (action.type.endsWith('_FAILURE')) {
        return [
            ...state,
            {
                'errorCode': action.code,
                'errorMessage': action.message,
                'failedAction': action.type,
                'suppressDefault': !!action.payload?.suppressErrors
            }
        ];
    }

    return state;
 };

export const getError = (state, actionType) => state?.find(({failedAction}) => failedAction === actionType) || null;
export default reduceError;
